module.exports = __webpack_public_path__ + "40b8c0e74b1270429a57985f0abd1ab5.fbx";